<template>
	<v-container grid-list-xl style="margin-left:3%; margin-right:3%; max-width: 94%;">
		<v-layout row wrap>
            <v-flex lg12 class="paddingBottomNone" v-if="objAuthorize.privileges.indexOf('VENDOR_CUSTOMER_DETAILS') || ( objAuthorize.type != '6' && objAuthorize.privileges.indexOf('VENDOR_HIDE_DETAILS') == -1 )">
              <strong>Quote Date:</strong><span>&nbsp;&nbsp;{{ globalModalParams.details.date }}</span><br />
              <strong>Customer Name:</strong>&nbsp;&nbsp;{{ globalModalParams.details.fullname }}<br />
              <strong>Customer Email:</strong>&nbsp;&nbsp;{{ globalModalParams.details.email }}<br />
              <strong>Customer Contact:</strong>&nbsp;&nbsp;<span v-if="globalModalParams.details.contactnum != ''">{{ globalModalParams.details.contactnum }}</span><span v-else>N/A</span>
              <div v-if="globalModalParams.details.items[0].sales_order_number != null && globalModalParams.details.items[0].sales_order_number != 0 && globalModalParams.details.items[0].sales_order_number != ''"><strong>Sales Order Number:</strong><span>&nbsp;&nbsp;{{ globalModalParams.details.items[0].sales_order_number }}</span></div>
            </v-flex>
            <v-flex lg12 class="paddingBottomNone" v-else>
              <strong>Quote Date:</strong><span>&nbsp;&nbsp;{{ globalModalParams.details.date }}</span>
              <div v-if="globalModalParams.details.items[0].sales_order_number != null && globalModalParams.details.items[0].sales_order_number != 0 && globalModalParams.details.items[0].sales_order_number != ''"><strong>Sales Order Number:</strong><span>&nbsp;&nbsp;{{ globalModalParams.details.items[0].sales_order_number }}</span></div>
            </v-flex>
			<v-flex lg12 class="userInfo">
              <v-data-table v-if="objAuthorize.privileges.indexOf('VENDOR_NO_PRICE') != -1" :search="search" :items="globalModalParams.details.items" class="elevation-1 middleTable minTable" style="font-size: 10px;" hide-actions>
                <template slot="headers" slot-scope="props">
                  <tr class="middle">
                    <th style="border: 1px solid #fff;" width="60%">ITEM</th>
                    <th style="border: 1px solid #fff;" width="20%">QUANTITY</th>
                    <th style="border: 1px solid #fff;" width="20%">UOM</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td width="60%" v-if="linkedProps.indexOf(props.item.p_key.toString()) == -1" class="text-xs-right" v-html="fncFilterName(props.item.itemName, false)">{{ fncFilterName(props.item.itemName) }}</td>
                  <td width="60%" v-else class="text-xs-right" v-html="fncFilterName(props.item.itemName, true)"></td>
                  <td width="20%" class="text-xs-right"><center>{{ props.item.quantity }}</center></td>
                  <td width="20%" class="text-xs-right"><center>{{ props.item.uom }}</center></td>
                </template>

              </v-data-table>
              <v-data-table v-if="objAuthorize.privileges.indexOf('VENDOR_NO_PRICE') == -1" :search="search" :items="globalModalParams.details.items" class="elevation-1 middleTable minTable" style="font-size: 10px;" hide-actions>
                <template slot="headers" slot-scope="props">
                  <tr class="middle">
                    <th style="border: 1px solid #fff;" width="50%">ITEM</th>
                    <th style="border: 1px solid #fff;" width="20%">QUANTITY</th>
                    <th style="border: 1px solid #fff;" width="10%">UOM</th>
                    <th style="border: 1px solid #fff;text-align: right !important; padding-right: 3% !important;" width="20%">TOTAL PRICE</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td width="50%" v-if="linkedProps.indexOf(props.item.p_key.toString()) == -1" class="text-xs-right" v-html="fncFilterName(props.item.itemName, false)">{{ fncFilterName(props.item.itemName) }}</td>
                  <td width="50%" v-else class="text-xs-right" v-html="fncFilterName(props.item.itemName, true)"></td>
                  <td width="20%" class="text-xs-right"><center>{{ props.item.quantity }}</center></td>
                  <td width="10%" class="text-xs-right"><center>{{ props.item.uom }}</center></td>
                  <td width="20%" class="text-xs-right" style="text-align: right !important; padding-right: 3% !important;">{{ fncFormatTotalNett(props.item, props.item.quantity, props.item.discount) }}</td>
                </template>
                <template slot="footer" style="padding-bottom: 10px;margin-top: 40px;">
                  <tr style="font-size: 12px !important; border: none !important; background-color: #fff !important; background: #fff !important; color: #000;">
                    <th width="80%" style="text-align: right !important;"><strong>TOTAL</strong></th>
                    <td width="20%" style="text-align: right !important;padding-right:3%;border-top: 1px solid grey;border-bottom: 1px solid grey;">{{ fncTotalNett() }}</td>
                  </tr>
                  <tr style="font-size: 12px !important; border: none !important; background-color: #fff !important; background: #fff !important; color: #000;padding-top: 10px;">
                    <th width="80%" style="text-align: right !important;height:20px;"></th>
                    <td width="20%" style="text-align: right !important;padding-right:3%;border-bottom: 1px solid grey; height:2px; width:100%; display: block;"></td>
                  </tr>
                </template>
              </v-data-table>
              <br />
        <div v-if="lineData.installation_customer_first_name != null" class="lineItemDetails">
          <br /><br /><h2>Installation Details</h2>
          <table cellpadding="10" width="100%" class="installation">
            <tr>
              <th class="installation-header" colspan="4"><strong>Customer Details</strong></th>
            </tr>
            <tr>
              <th width="25%">First Name</th>
              <th width="25%">Last Name</th>
              <th width="25%">Email Address</th>
              <th width="25%">Contact Number</th>
            </tr>
            <tr>
              <td width="25%">{{ lineData.installation_customer_first_name }}</td>
              <td width="25%">{{ lineData.installation_customer_last_name }}</td>
              <td width="25%">{{ lineData.installation_customer_email }}</td>
              <td width="25%">{{ lineData.installation_customer_contact_number }}</td>
            </tr>
          </table>
          <br />
          <table cellpadding="10" width="100%" class="installation">
            <tr>
              <th class="installation-header" colspan="4"><strong>Address Details</strong></th>
            </tr>
            <tr>
              <th width="50%" colspan="2">Address Found</th>
              <th width="50%" colspan="2">Address Searched</th>
            </tr>
            <tr>
              <td width="50%" colspan="2">{{ lineData.installation_address_found }}</td>
              <td width="50%" colspan="2">{{ lineData.installation_address_searched }}</td>
            </tr>
            <tr>
              <th width="25%">Suburb</th>
              <th width="25%">Province</th>
              <th width="25%">Installation Lat</th>
              <th width="25%">Installation Long</th>
            </tr>
            <tr>
              <td width="25%">{{ lineData.installation_address_suburb }}</td>
              <td width="25%">{{ lineData.installation_address_province }}</td>
              <td width="25%">{{ lineData.installation_address_install_lat }}</td>
              <td width="25%">{{ lineData.installation_address_install_long }}</td>
            </tr>
            <tr>
              <th width="25%">Store Lat</th>
              <th width="25%">Store Long</th>
              <th width="25%">Store Name</th>
              <th width="25%">Store Code</th>
            </tr>
            <tr>
              <td width="25%">{{ lineData.installation_address_store_lat }}</td>
              <td width="25%">{{ lineData.installation_address_store_long }}</td>
              <td width="25%">{{ lineData.installation_address_store_name }}</td>
              <td width="25%">{{ lineData.store_id }}</td>
            </tr>
          </table>
          <br />
          <table cellpadding="10" width="100%" class="installation">
            <tr>
              <th class="installation-header" colspan="4"><strong>Install Details</strong></th>
            </tr>
            <tr>
              <th width="20%">Appointment Date Start</th>
              <th width="20%">Appointment Date End</th>
              <th width="20%">Appointment Contact Number</th>
              <th width="20%">Appointment Contact Person</th>
              <th width="20%">Lookup Service Rep</th>
            </tr>
            <tr>
              <td width="20%" v-html="fncDisplayDate(lineData.installation_appointment_date_start)"></td>
              <td width="20%">{{ lineData.installation_appointment_date_end }}</td>
              <td width="20%">{{ lineData.installation_appointment_contact_number }}</td>
              <td width="20%">{{ lineData.installation_appointment_contact_person }}</td>
              <td width="20%">{{ lineData.installation_lookup_service_ref }}</td>
            </tr>
            <tr>
              <th class="installation-header" width="80%" colspan="4">Appointment Installation Notes</th>
              <th width="20%">Installation Sales Order Number</th>
            </tr>
            <tr>
              <td width="80%" colspan="5">{{ lineData.installation_notes }}</td>
              <td width="20%">{{ lineData.installation_sales_order_number }}</td>
            </tr>
          </table>
          <br />
          <table cellpadding="10" width="100%" class="installation">
            <tr>
              <th colspan="4"><strong>Product Details</strong></th>
            </tr>
            <tr>
              <th width="16.66%">Product Description</th>
              <th width="16.66%">Product Make</th>
              <th width="16.66%">Product Type</th>
              <th width="16.66%">Product SKU</th>
              <th width="16.66%">Product MO ID</th>
              <th width="16.66%">Product QTY</th>
            </tr>
            <tr v-if="productCount >= 1">
              <td width="16.66%">{{ lineData.installation_product_description_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_1 }}</td>
            </tr>
            <tr v-if="productCount >= 2">
              <td width="16.66%">{{ lineData.installation_product_description_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_2 }}</td>
            </tr>
            <tr v-if="productCount >= 3">
              <td width="16.66%">{{ lineData.installation_product_description_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_3 }}</td>
            </tr>
            <tr v-if="productCount >= 4">
              <td width="16.66%">{{ lineData.installation_product_description_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_4 }}</td>
            </tr>
            <tr v-if="productCount >= 5">
              <td width="16.66%">{{ lineData.installation_product_description_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_5 }}</td>
            </tr>
          </table>
          <br />
        </div>
        <div class="lineItemDetails">
          <!--<div class="lineItemDetail" v-html="item.spec" v-if="item.linked_props != '' || singleQuoteData.details.length == 1" v-for="(item, key) in singleQuoteData.details">-->
          <!--<div class="lineItemDetail" v-for="(item, key) in singleQuoteData.details">
            <div v-html="fncShowSpec(item.spec, key)"></div>
          </div>-->
          <div class="lineItemDetail" v-html="fncShowSpec(singleQuoteData.details)"></div>
        </div>
			</v-flex>
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">
                    <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
                    <v-btn v-if="objAuthorize.privileges.indexOf('VENDOR_FACTORY') == -1" color="success" class="text-xs-right" @click.stop="fncDownloadCsv"><i class="material-icons">file_copy</i>Download Excel Summary</v-btn>
                    <v-btn color="success" class="text-xs-right" @click.stop="fncDownloadPdf"><i class="material-icons">description</i>Download PDF</v-btn>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
              objUser: 0,
              search: '',
              totalNett: 0,
              totalVat: 0,
              totals: [],
              linkedProps: [],
              newSingleQuoteData: [],
              singleQuoteData: [],
              lineData: ''
			};
		},
      methods: {
        fncDisplayDate( dateString ) {
          var objDates = dateString.split(',');

          var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';

          if( objDates.length > 1 ) {
            toReturn += '<small><strong>OLD DATES</strong></small><br />';
            for( var d in objDates ) {
              if( objDates[d] != objDates[objDates.length - 1] ) {
                toReturn += '<small>'+objDates[d]+'</small><br />';
              }
            }
          }
          return toReturn;
        },
        fncShowSpec( spec, num ) {
          /*if( num == 0 ) {
            return spec;
          } else {
            return '';
          }*/
          var addedSpecs = [];
          var addedFinalSpecs = [];
          for( var s in spec ) {
            //addedSpecs.push( spec[s].spec );
            addedSpecs[spec[s].spec] = '';
          }
          var strReturn = '';
          for( var a in addedSpecs ) {
            strReturn += a;
          }
          return strReturn;
          /*if( this.addedSpecs[spec] == '' || this.addedSpecs[spec] == undefined || this.addedSpecs[spec] == null ) {
            this.addedSpecs.push(spec);
            return spec;
          }*/
        },
        fncDownloadCsv() {
          this.$store.dispatch({
            type: 'fncDownloadReportCsv',
            data: this.globalModalParams.details,
            vendorList: this.vendorList,
            privileges: this.objAuthorize.privileges
          })
        },
        fncDownloadPdf() {
          //this.$store.dispatch('fncDownloadReportPdf', this.globalModalParams.details);

          for( var v in this.vendorList ) {
            if( this.vendorList[v].id == this.globalModalParams.details.vendor ) {
              this.globalModalParams.details.vendorDetails = this.vendorList[v];
            }
          }

          this.$store.dispatch('fncDownloadReportPoPdf', this.globalModalParams.details);
        },
            fncFilterName(name, isProp) {
              var dataUrl = name.replace(/%20/g, " ");
              dataUrl = dataUrl.replace(/%27/g, "'");
              dataUrl = dataUrl.replace(/%3A/g, ":");
              dataUrl = dataUrl.replace(/%3B/g, ";");
              dataUrl = dataUrl.replace(/%3C/g, "<");
              dataUrl = dataUrl.replace(/%3D/g, "=");
              dataUrl = dataUrl.replace(/%3E/g, ">");
              dataUrl = dataUrl.replace(/%2C/g, ",");
              dataUrl = dataUrl.replace(/%28/g, "(");
              dataUrl = dataUrl.replace(/%29/g, ")");
              dataUrl = dataUrl.replace(/&sup/g, "");
              dataUrl = dataUrl.replace(/;/g, "");

              if ( isProp == true ) {
                return '<span style="display: block; padding-left: 20px;">-&nbsp;&nbsp;' + dataUrl+'</span>';
              } else {
                return dataUrl;
              }

            },
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncFilterPrice(filterVar) {
              var currencyValue = parseFloat(filterVar).toFixed(2);
              currencyValue = currencyValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + currencyValue;
            },
            fncFormatPerc(filterDiscount, ) {
              return parseFloat(filterVar).toFixed(2) + '%';
            },
            fncFormatNett(filterPrice, filterDiscount) {
              var finalPrice = parseFloat( parseFloat(filterPrice) - parseFloat(filterDiscount) ).toFixed(2);
              var nettValue = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + nettValue;
            },
            fncFormatTotal(filterPrice, filterQty) {
              var finalPrice = (filterPrice * filterQty).toFixed(2);
                  finalPrice = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + finalPrice;
            },
            fncFormatTotalNett(filterPrice, filterQty, filterDiscount) {

              if (this.objAuthorize.privileges.indexOf('VENDOR_COST_PRICE') != -1) {
                var lineData = JSON.parse(filterPrice.line_item_data);
                if (lineData.cost_price != null) {
                  filterPrice = lineData.cost_price;
                } else {
                  filterPrice = filterPrice.price;
                }
              // } else if (this.objAuthorize.privileges.indexOf('VENDOR_FULL_PRICE') != -1) {
              } else {
                filterPrice = filterPrice.price;
              }

              var finalPrice = (parseFloat(parseFloat(filterPrice) - parseFloat(filterDiscount)).toFixed(2) * filterQty).toFixed(2);
              var nettValue = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + nettValue;
            },
            fncCalculateVat() {
              var totalVat = parseFloat(this.totalNett * this.globalModalParams.vat).toFixed(2);
              this.totalVat = totalVat;
                  totalVat = totalVat.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + totalVat;
            },
            fncFinalTotal() {
              var finalTotal = parseFloat(parseFloat(this.totalNett) + parseFloat(this.totalVat)).toFixed(2);
              finalTotal = finalTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + finalTotal;
            },
            fncTotalNett() {

              var totalNett = 0;

              if (this.objAuthorize.privileges.indexOf('VENDOR_COST_PRICE') != -1) {
                for (var k in this.globalModalParams.details.items) {
                  var price = 0;
                  var lineData = JSON.parse(this.globalModalParams.details.items[k].line_item_data);
                  if (lineData.cost_price != null) {
                    price = lineData.cost_price;
                  } else {
                    price = this.globalModalParams.details.items[k].price
                  }
                  var addPrice = (parseFloat(parseFloat(price) - parseFloat(this.globalModalParams.details.items[k].discount)).toFixed(2) * this.globalModalParams.details.items[k].quantity).toFixed(2);
                  totalNett = totalNett + parseFloat(addPrice);
                }
              } else {
              // } else if (this.objAuthorize.privileges.indexOf('VENDOR_FULL_PRICE') != -1) {
                for (var k in this.globalModalParams.details.items) {
                    price = this.globalModalParams.details.items[k].price
                    var addPrice = (parseFloat(parseFloat(price) - parseFloat(this.globalModalParams.details.items[k].discount)).toFixed(2) * this.globalModalParams.details.items[k].quantity).toFixed(2);
                    totalNett = totalNett + parseFloat(addPrice);
                }
              }
              this.totalNett = totalNett.toFixed(2);
              totalNett = totalNett.toFixed(2);
              totalNett = totalNett.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + totalNett;
            }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
                'singleQuoteData',
                'vendorList'
			])
      },
        mounted() {
          for (var i in this.globalModalParams.details.items) {
            if (this.globalModalParams.details.items[i].linked_props != '' ) {
              var objProps = this.globalModalParams.details.items[i].linked_props.split(',');
              this.linkedProps = this.linkedProps.concat(objProps);
            }
          }
        },
    beforeMount() {

      this.newSingleQuoteData.details = this.globalModalParams.quoteDetails;
      this.newSingleQuoteData.attachment = this.globalModalParams.quoteAttachments;
      this.newSingleQuoteData.quote = this.globalModalParams.quoteDetails;

      this.singleQuoteData = this.newSingleQuoteData;

      this.lineData = this.newSingleQuoteData.details[0].line_item_data;
      this.lineData = JSON.parse( this.lineData );

      var lineDataCount = Object.keys(this.lineData).length;
      lineDataCount = lineDataCount - 25;
      this.productCount = ( lineDataCount / 6 );

    },
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
